<template>
  <div v-if="props.sizeCharts && props.sizeCharts.length" class="pt-3">
    <button class="flex gap-1.5 items-center a-link" @click="isModalOpen = true">
      <SizeChartIcon size="22" />
      <p class="font-semibold cursor-pointer py-1">
        {{ $t('sizeChart') }}
      </p>
    </button>

    <BaseModal v-if="props.sizeCharts && props.sizeCharts.length" :open="isModalOpen" @close="isModalOpen = false">
      <p class="gamma mb-4">
        {{ $t('sizeChart') }}
      </p>
      <div class="flex flex-col items-center gap-6 -mx-4 -sm:mx-8">
        <div v-for="sizeChart in props.sizeCharts" :key="sizeChart.url" class="w-full flex flex-col items-center">
          <img :src="sizeChart.url" :alt="sizeChart.alt" class="w-full h-auto object-contain">
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script setup lang="ts">
import type { ProductAlgolia } from '~/types/product'
import { SizeChartIcon } from '~/components/icon'

const props = defineProps<{
  sizeCharts: ProductAlgolia['sizeCharts']
}>()

const isModalOpen = ref(false)
</script>
